var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4528_6585)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4528_6585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7563 10.0252L21.7281 9.28045C21.546 8.70641 21.3119 8.14974 21.0294 7.61725C21.4841 6.86042 22.4396 5.2675 22.4396 5.2675C22.6224 4.96312 22.574 4.57336 22.3232 4.32261L20.1359 2.13523C19.8851 1.88371 19.4961 1.83539 19.191 2.0189L16.8374 3.42909C16.3079 3.14884 15.7543 2.91697 15.1841 2.73645L14.4393 -0.291767C14.3532 -0.636205 14.0443 -0.87793 13.6893 -0.87793H10.5955C10.2405 -0.87793 9.93082 -0.636205 9.84548 -0.291819C9.84548 -0.291819 9.3296 1.82173 9.10148 2.73567C8.49346 2.92826 7.90585 3.17829 7.34614 3.48343L4.90574 2.0189C4.60059 1.83761 4.21238 1.88448 3.96086 2.13523L1.77347 4.32261C1.52273 4.57336 1.47436 4.96312 1.65715 5.2675L3.16628 7.78797C2.92306 8.26761 2.71913 8.76684 2.55676 9.27818L-0.471455 10.0252C-0.815892 10.1113 -1.05762 10.4202 -1.05762 10.7752V13.8689C-1.05762 14.224 -0.815892 14.5336 -0.471506 14.619L2.55748 15.3637C2.74104 15.946 2.97968 16.5118 3.26899 17.0548L1.91852 19.3056C1.73573 19.61 1.7841 19.9998 2.03484 20.2505L4.22223 22.4379C4.47226 22.6879 4.86196 22.7355 5.16711 22.5542C5.16711 22.5542 6.6815 21.6464 7.42323 21.2022C7.96025 21.4885 8.52218 21.7249 9.10154 21.9084L9.84553 24.9359C9.93082 25.2804 10.2405 25.5221 10.5955 25.5221H13.6893C14.0443 25.5221 14.3532 25.2803 14.4393 24.936L15.1833 21.9085C15.7792 21.7196 16.3532 21.4757 16.8993 21.1796C17.6614 21.6365 19.1909 22.5542 19.1909 22.5542C19.4953 22.7363 19.8851 22.6894 20.1358 22.4379L22.3232 20.2505C22.5739 19.9998 22.6223 19.61 22.4395 19.3056L21.049 16.9891C21.3231 16.4687 21.5505 15.9241 21.728 15.3637L24.7562 14.619C25.1007 14.5329 25.3424 14.224 25.3424 13.8689V10.7752C25.3424 10.4202 25.1007 10.1113 24.7563 10.0252ZM12.1424 17.7361C9.15738 17.7361 6.72832 15.3071 6.72832 12.3221C6.72832 9.33707 9.15738 6.90801 12.1424 6.90801C15.1274 6.90801 17.5564 9.33707 17.5564 12.3221C17.5564 15.3071 15.1274 17.7361 12.1424 17.7361Z",
    fill: "#0C4480"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4528_6585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4528_6585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.4,
    height: 26.4,
    fill: "white",
    transform: "translate(-1.05762 -0.87793)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.801b81390912d25b78716125dba06e63.svg";
export { ForwardRef as ReactComponent };